import React, { FunctionComponent } from 'react'
import { LoginToAdminButton } from '../AccountList/LoginToAdminButton';
import { IUser } from '../../../types/resources';

export const UserAccountLogin: FunctionComponent<{ value: IUser }> = ({ value }) => {
    return (
      <LoginToAdminButton value={value.account!} />
    );
}